import React from "react";
import styled from "styled-components";
import bg from "../../src/assets/images/bg.jpg"; // Ensure path is correct

const EmbrakSection = () => {
  return (
    <SectionWrapper>
      <Overlay>
        <Content>
          <h3> "At Embark Properties, we don’t just find you a place — we help you start a new journey." </h3>
          
        </Content>
      </Overlay>
    </SectionWrapper>
  );
};

export default EmbrakSection;

// Styled Components
const SectionWrapper = styled.section`
  background-image: url(${bg});
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  height: 80vh;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Overlay = styled.div`
  background: rgba(0, 0, 0, 0.5); /* dark overlay for readability */
  width: 100%;
  height: 100%; /* Full height of the section */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
`;

const Content = styled.div`
  color: #fff;
  text-align: center;
  max-width: 700px;

  h3 {
    font-size: 2.5rem;
    margin-bottom: 20px;
    font-family: "Paris Avenue";
  }

  p {
    font-size: 1.125rem;
    line-height: 1.6;
  }
`;
